module.exports = __webpack_public_path__ + "static/media/heartnew.4774d374.svg";